/* eslint-disable */

// columns = [{ field: 'id', headerName: 'ID' }, ...]
// rows = [{ id: 1, name: 'User1', ... }, ...]

export function handlePrint(columns, rows) {
 console.log('step1');

 // שלב 1: מדידת הטבלה בצורה בלתי נראית (Offscreen) כדי לדעת אם היא נכנסת לרוחב עמוד A4
 const hiddenContainer = document.createElement('div');
 hiddenContainer.style.position = 'absolute';
 hiddenContainer.style.visibility = 'hidden';
 hiddenContainer.style.height = 'auto';
 hiddenContainer.style.width = 'auto';
 hiddenContainer.style.zIndex = '-9999';

 // בונים טבלה בסיסית ב-DOM הראשי, מוסתרים:
 let tableHTML = createMaterialLikeTable(columns, rows);
 hiddenContainer.innerHTML = tableHTML;

 // מוסיפים ל-document.body באופן זמני
 document.body.appendChild(hiddenContainer);

 // בודקים את הרוחב האמיתי של הטבלה ב-px
 const tableElement = hiddenContainer.querySelector('.mui-like-table');
 const tableWidth = tableElement ? tableElement.offsetWidth : 0;

 // בקירוב: רוחב דף A4 בפורטרט ~794px ב-96 dpi (תלוי הגדרות)
 // אם הטבלה עולה על ~750px, נדפיס לרוחב
 let orientation = 'portrait';
 if (tableWidth > 750) {
   console.log('לא מתאים לרוחב');
   orientation = 'landscape';
 } else {
   console.log('מתאים לרוחב');
 }

 // מנקים את ה-offscreen container
 document.body.removeChild(hiddenContainer);

 // שלב 2: פותחים חלון חדש, בונים בו את ה-HTML עם orientation מתאים
 const printWindow = window.open('', '_blank', 'width=900,height=600');
 if (!printWindow) {
   console.error('חלון ההדפסה נחסם על ידי הדפדפן.');
   return;
 }

 // שלב 3: יוצרים תוכן HTML מלא להדפסה
 const fullHtml = buildPrintHtml(columns, rows, orientation);

 // כתיבה לתוך החלון
 printWindow.document.open();
 printWindow.document.write(fullHtml);
 printWindow.document.close();

 // שלב 4: קריאה ל-print אחרי המתנה קצרה
 setTimeout(() => {
   printWindow.focus();
   printWindow.print();
   // printWindow.close(); // אם רוצים לסגור אוטומטית
 }, 500);
}

// ------------------------------------------------------------------------
// פונקציה שבונה טבלת HTML בסיסית בעיצוב דמוי Material-UI (כדי למדוד וגם להדפיס)

function createMaterialLikeTable(columns, rows) {
 // נוסיף class 'mui-like-table' לזיהוי
 // נשתמש ב-<table> עם קצת classes ו-style inline שמדמים MUI מינימלי
 // אפשר כמובן להרחיב
 return `
  <table class="mui-like-table" style="
    border-collapse: collapse;
    font-family: 'Roboto', sans-serif;
    width: 100%;
  ">
    <thead style="
      background-color: #f5f5f5;
    ">
      <tr>
        ${columns
          .map(
            (col) => `
          <th style="
            border: 1px solid #ccc;
            padding: 8px;
            text-align: left;
          ">
            ${col.headerName || col.field}
          </th>
        `
          )
          .join('')}
      </tr>
    </thead>
    <tbody>
      ${rows
        .map((row) => {
          return `
            <tr>
              ${columns
                .map((col) => {
                  const val = row[col.field] !== undefined ? row[col.field] : '';
                  return `
                    <td style="
                      border: 1px solid #ccc;
                      padding: 8px;
                    ">
                      ${val}
                    </td>`;
                })
                .join('')}
            </tr>
          `;
        })
        .join('')}
    </tbody>
  </table>
`;
}

// ------------------------------------------------------------------------
// פונקציה שבונה את ה-HTML הסופי להדפסה
// ( ביטלנו position: fixed והוספנו thead/tfoot אמיתי )

function buildPrintHtml(columns, rows, orientation) {
 // כאן מבטלים את הרכיבים המקובעים ומסתמכים על margin ב-@page
 // ויוצרים thead/tfoot אמיתיים (שיחזרו בעמודים הבאים).

 // 1) נבנה thead, tfoot מותאמים
 //    נוסיף שורת כותרת עליונה (אפשר אפילו שורה נוספת מעבר לכותרות העמודות)
 //    נוסיף שורת תחתונה עם \"footer\" כלשהו
 const theadHtml = `
   <thead>
     <!-- שורה עליונה - כותרת כללית לטבלה (תחזור בכל עמוד) -->
     <tr><th style="border:1px solid #ccc; padding:8px; text-align:center;" colspan="${columns.length}">
       כותרת עליונה של כל עמוד
     </th></tr>

     <!-- שורת כותרות העמודות (גם תחזור בכל עמוד) -->
     <tr style="background-color: #f5f5f5;">
     ${columns
       .map(
         (col) => `
           <th style="border:1px solid #ccc; padding:8px; text-align:left;">
             ${col.headerName || col.field}
           </th>
         `
       )
       .join('')}
     </tr>
   </thead>
 `;

 const tfootHtml = `
   <tfoot>
     <!-- שורה תחתונה שתשוכפל בכל עמוד -->
     <tr>
       <td style="border:1px solid #ccc; padding:8px; text-align:center;" colspan="${columns.length}">
         כותרת תחתונה של כל עמוד
       </td>
     </tr>
   </tfoot>
 `;

 // 2) נבנה את ה-rows של ה-tbody כרגיל
 const tbodyHtml = `
   <tbody>
     ${rows
       .map((row) => {
         return `
           <tr>
             ${columns
               .map((col) => {
                 const val = row[col.field] !== undefined ? row[col.field] : '';
                 return `
                   <td style="
                     border: 1px solid #ccc;
                     padding: 8px;
                     text-align: left;
                   ">
                     ${val}
                   </td>`;
               })
               .join('')}
           </tr>
         `;
       })
       .join('')}
   </tbody>
 `;

 // 3) עוטפים הכל בטבלה אחת, בלי .content ובלי divים fixed
 // 4) מגדירים @page margin כדי לאפשר שוליים
 const styles = `
 <style>
   @page {
     size: A4 ${orientation};
     margin: 20mm; /* אפשר לשנות לפי רצונך */
   }
   thead { 
     display: table-header-group; 
   }
   tfoot {
     display: table-footer-group;
   }
   table {
     width: 100%;
     border-collapse: collapse;
     direction: rtl;
     font-family: 'Roboto', sans-serif;
   }
   th, td {
     border: 1px solid #ccc;
     padding: 8px;
   }
 </style>
 `;

 // 5) מרכיבים HTML מלא
 return `
  <!DOCTYPE html>
  <html lang="en">
  <head>
    <meta charset="UTF-8"/>
    ${styles}
  </head>
  <body>
    <!-- כאן הטבלה עצמה (thead + tbody + tfoot) -->
    <table>
      ${theadHtml}
      ${tbodyHtml}
      ${tfootHtml}
    </table>
  </body>
  </html>
 `;
}
